@if (isLoader) {
  <bmcore-loader></bmcore-loader>
}

<form [formGroup]="signUpForm" (ngSubmit)="onSubmit()">
  <div class="sign-up-form">
    <bmcore-input formControlName="nickname" [title]="'Nickname'" [type]="'text'" [controlFormName]="'nickname'">
    </bmcore-input>
    <bmcore-input formControlName="email" [title]="'Email'" [type]="'email'" [controlFormName]="'email'">
    </bmcore-input>
    <bmcore-input formControlName="password" [title]="'Password'" [type]="'password'" [controlFormName]="'password'">
    </bmcore-input>
    <bmcore-input
      formControlName="confirmPassword"
      [title]="'Confirm password'"
      [type]="'password'"
      [controlFormName]="'confirmPassword'"
    >
    </bmcore-input>
  </div>

  <div class="bm--auth-form-btn-container">
    <bmcore-button title="Sign up" styleName="center" [disabled]="isLoader"> </bmcore-button>
  </div>
</form>
